module.exports = __webpack_public_path__ + "assets/img/kv-18040bb3.jpg";